import { OnlineEventType } from '@core/enums/event/online-event-type.enum';
import { TicketTemplateBoxofficeType } from '@core/enums/ticket-template-boxoffice-type.enum';
import { IChannelSettings } from '@core/interfaces/event/event-channel-settings.interface';
import { IEventView } from '@core/interfaces/event/event-view.interface';
import { AAGUID, ISODateTime, parseArray } from '@interticket/core';
import { DateTime } from 'luxon';
import { Auditorium } from '../auditorium/auditorium.model';
import { EventBase } from './event-base.model';
import { ChannelSettings } from './event-channel-settings.model';
import { DefaultChannelSettings } from './event-default-channel-settings.model';

export class EventView extends EventBase implements IEventView {

  readonly admissionFrom: ISODateTime;
  readonly admissionTo: ISODateTime;
  readonly auditorium: Auditorium;
  readonly categories: AAGUID[];
  readonly channelSettings: ChannelSettings[];
  readonly defaultBoxOfficeTicketFormatType: TicketTemplateBoxofficeType;
  readonly defaultChannelSettings: DefaultChannelSettings;
  readonly duration: number;
  readonly gallery: AAGUID[];
  readonly isActive: boolean;
  readonly isDeleted: boolean;
  readonly isPrivate: boolean;
  readonly longDescription: string;
  readonly ownerPartnerId: AAGUID;
  readonly playbackId: AAGUID;
  readonly programId: AAGUID;
  readonly taxId: AAGUID;
  readonly useProgramData: boolean;
  readonly ticketValidity: number;
  readonly ticketValidityDays: number;
  readonly ticketValidityHours: number;

  constructor(iEventView: IEventView) {
    super(iEventView);

    this.admissionFrom = iEventView.admissionFrom;
    this.admissionTo = iEventView.admissionTo;
    this.auditorium = new Auditorium(iEventView.auditorium);
    this.categories = iEventView.categories;
    this.channelSettings = parseArray<IChannelSettings, ChannelSettings>(iEventView.channelSettings, ChannelSettings);
    this.defaultBoxOfficeTicketFormatType = iEventView.defaultBoxOfficeTicketFormatType;
    this.defaultChannelSettings = new DefaultChannelSettings(iEventView.defaultChannelSettings);
    this.duration = iEventView.duration;
    this.gallery = iEventView.gallery;
    this.isActive = iEventView.isActive;
    this.isDeleted = iEventView.isDeleted;
    this.isPrivate = iEventView.isPrivate;
    this.longDescription = iEventView.longDescription;
    this.ownerPartnerId = iEventView.ownerPartnerId;
    this.playbackId = iEventView.playbackId;
    this.programId = iEventView.programId;
    this.taxId = iEventView.taxId;
    this.useProgramData = iEventView.useProgramData;
    this.ticketValidity = iEventView.ticketValidity;
    this.ticketValidityDays = this.ticketValidity > 0 ? Math.floor(this.ticketValidity / 24) : 0;
    this.ticketValidityHours = this.ticketValidity > 0 ? this.ticketValidity % 24 : 0;
    this.duration = this.getDuration(iEventView.duration);
  }

  private getDuration(duration: number): number {
    if (this.onlineEventType === OnlineEventType.LIVESTREAM_VIDEO && typeof duration !== 'number') {
      return Math.round(DateTime.fromISO(this.livestreamEndDate).diff(DateTime.fromISO(this.startDate), 'minute').minutes);
    }
    return duration;
  }

}
